import { api } from './client'

export async function getStorefront(
  slug: string,
  serviceDate?: string,
  serviceKey?: string,
) {
  const { data, error, response } = await api.GET(
    '/api/v1/public/kitchens/{slug}',
    {
      params: {
        path: { slug },
        query:
          serviceDate || serviceKey
            ? { service_date: serviceDate, service_key: serviceKey }
            : undefined,
      },
    },
  )
  if (!data) {
    const message =
      error && typeof error === 'object' && 'error' in error
        ? String((error as { error?: { message?: string } }).error?.message)
        : `Storefront request failed (${response.status})`
    throw new Error(message)
  }
  return data
}

export async function checkServiceability(slug: string, pincode: string) {
  const { data, error, response } = await api.GET(
    '/api/v1/public/kitchens/{slug}/serviceability',
    { params: { path: { slug }, query: { pincode } } },
  )
  if (!data)
    throw new Error(
      `Serviceability check failed (${response.status}): ${String(error)}`,
    )
  return data
}
